import { PlaceholderShape } from '@/features/shared/placeholder/PlaceholderShape';
import { Theme } from '@/utils/constants';
import React from 'react';
import { useEsTabbedPlaceholderContentStyles } from './EsTabbedContent.styles';

const EsTabbedContentPlaceholder = () => {
  const styles = useEsTabbedPlaceholderContentStyles();

  return (
    <div className={styles.placeholder}>
      <div className="tabs-content">
        {[...Array(4)].map(() => (
          <div className="tabs-panel placeholder">
            <PlaceholderShape
              theme={Theme.dark}
              level="1"
              className="tab-panel-image"
              roundedTopLeft
              roundedTopRight
            />
            <PlaceholderShape
              className="tab-panel-content"
              theme={Theme.dark}
              level="2"
              roundedBottomLeft
              roundedBottomRight
            >
              <PlaceholderShape theme={Theme.dark} level="1" className="tab-panel-title" />
              {[...new Array(8)].map(() => (
                <PlaceholderShape theme={Theme.dark} level="1" className="tab-panel-text-line" />
              ))}
            </PlaceholderShape>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EsTabbedContentPlaceholder;
